// Resolved on demand rather than at module-eval time. This module is reached
// while the pack's entry chunk is still evaluating, which is both before
// #organization-data is guaranteed to be in the DOM and before jQuery (a
// Sprockets global, not a webpack import) is guaranteed to exist. Touching $
// here aborted the whole entry chunk when the Sprockets bundle had not run.
function attr(name) {
  const element = document.getElementById('organization-data');
  const value = element ? element.getAttribute(name) : null;

  // Match jQuery .attr(), which yields undefined rather than null when absent.
  return value === null ? undefined : value;
}

function getRegion() {
  return attr('data-region');
}

function getCurrency() {
  return attr('data-currency');
}

function getCurrencySymbol() {
  return attr('data-currency-symbol');
}

function getCurrencyNamePlural() {
  return attr('data-currency-name-plural');
}

export default {
  getRegion,
  getCurrency,
  getCurrencySymbol,
  getCurrencyNamePlural,
};
